"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldSidesheetWidth = exports.EmeraldSidesheetType = void 0;
var EmeraldSidesheetType;
(function (EmeraldSidesheetType) {
    EmeraldSidesheetType["Modal"] = "modal";
    EmeraldSidesheetType["Dismissible"] = "dismissible";
})(EmeraldSidesheetType || (exports.EmeraldSidesheetType = EmeraldSidesheetType = {}));
var EmeraldSidesheetWidth;
(function (EmeraldSidesheetWidth) {
    EmeraldSidesheetWidth["Small"] = "small";
    EmeraldSidesheetWidth["Medium"] = "medium";
    EmeraldSidesheetWidth["Wide"] = "wide";
    EmeraldSidesheetWidth["Extended"] = "extended";
    EmeraldSidesheetWidth["Full"] = "full";
})(EmeraldSidesheetWidth || (exports.EmeraldSidesheetWidth = EmeraldSidesheetWidth = {}));
//# sourceMappingURL=sidesheet.type.js.map